import { EMPTY_SKILL_SELECT, FETCH_SKILL_SELECT_SUCCESS } from "../ActionTypes";

const INIT_STATE = {
    skillSelectFetched: [],
    isFetched: false,
}

function reducers(state = INIT_STATE, action) {
    switch (action.type) {
        case FETCH_SKILL_SELECT_SUCCESS: {
            return {
              ...state,
              skillSelectFetched: action.payload,
              isFetched: true,
            };
          }
          case EMPTY_SKILL_SELECT: {
            return {
              ...state,
              skillSelectFetched: [],
            };
          }
      default:
      return state;
  }
}

export default reducers;